import {
  FETCH_SCHEDULE_BLOCK_REQUEST,
  FETCH_SCHEDULE_BLOCK_SUCCESS,
  FETCH_SCHEDULE_BLOCK_ERROR,
  SAVE_SCHEDULE_BLOCK_REQUEST,
  SAVE_SCHEDULE_BLOCK_SUCCESS,
  SAVE_SCHEDULE_BLOCK_ERROR,
  DELETE_SCHEDULE_BLOCK_REQUEST,
  DELETE_SCHEDULE_BLOCK_SUCCESS,
  DELETE_SCHEDULE_BLOCK_ERROR,
  FETCH_BRANCHS_REQUEST,
  FETCH_BRANCHS_SUCCESS,
  FETCH_BRANCHS_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  filters: {
    dsScheduleBlock: '',
    branchList: [],
    dtBegin: '',
    dtEnd: '',
    inRepeatAnnually: '',
  },
  list: {
    records: [],
    error: null,
    isFetching: false,
  },
  save: {
    isUpdating: false,
    error: null,
    updated: false,
  },
  delete: {
    isDeleting: false,
    error: null,
    deleted: false,
  },
  branch: {
    records: [],
    error: null,
    isFetching: false,
  },
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_BRANCHS_REQUEST:
      return {
        ...state,
        branch: {
          ...state.branch,
          isFetching: true,
          error: null,
        },
      }

    case FETCH_BRANCHS_SUCCESS:
      return {
        ...state,
        branch: {
          ...state.branch,
          isFetching: false,
          error: null,
          records: action.payload,
        },
      }

    case FETCH_BRANCHS_ERROR:
      return {
        ...state,
        branch: {
          ...state.branch,
          isFetching: false,
          records: [],
          error: action.payload,
        },
      }

    case FETCH_SCHEDULE_BLOCK_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
          error: null,
        },
      }

    case FETCH_SCHEDULE_BLOCK_SUCCESS:
      return {
        ...state,
        filters: action.filters,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
        },
      }

    case FETCH_SCHEDULE_BLOCK_ERROR:
      return {
        ...state,
        filters: action.filters,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: action.payload,
        },
      }

    case SAVE_SCHEDULE_BLOCK_REQUEST:
      return {
        ...state,
        save: {
          ...state.save,
          updated: false,
          isUpdating: true,
        },
      }

    case SAVE_SCHEDULE_BLOCK_SUCCESS:
      return {
        ...state,
        save: {
          ...state.save,
          updated: true,
          isUpdating: false,
          error: null,
        },
      }

    case SAVE_SCHEDULE_BLOCK_ERROR:
      return {
        ...state,
        save: {
          ...state.save,
          isUpdating: false,
          error: action.payload.error,
        },
      }

    case DELETE_SCHEDULE_BLOCK_REQUEST:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          isDeleting: true,
        },
      }

    case DELETE_SCHEDULE_BLOCK_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
          isDeleting: false,
          error: null,
        },
      }

    case DELETE_SCHEDULE_BLOCK_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          isDeleting: false,
          error: action.payload.error,
        },
      }
    default:
      return state
  }
}

export default record
